import { OnInit } from '@angular/core';
import { ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import * as $ from 'jquery';

export class urls {

	config;
	// cas = 'http://localhost:9000/';
	cas = 'https://cas.miurabox.com/';

	// public car_types  	     	: string;

	// public login	         	: string = this.cas + 'us-login-multicotizador';
	public login	         	: string;

	// URLS PRIMER FORMULARIO (INFORMACIÓN DEL AUTO)
	public car_types  	     	: string;
	public car_brands        	: string;
	public car_years         	: string;
	public car_models        	: string;

	// URLS SEGUNDO FORMULARIO (INFORMACIÓN GENERAL)
	public get_cities        	: string;
	public get_cols_by_city  	: string;
	public get_cols_by_zip   	: string;
	public get_states        	: string;
	public get_zip_by_col    	: string;

	// URLS COMPARACIÓN DE COTIZACIONES
	public get_new_car_model 	: string;
	public run_another_service	: string;
	public get_services      	: string;
	public pdf    		     	: string;
	public pdf_gnp    		    : string;
	public run_service       	: string;
	public send_email	     	: string;
	public send_email_pets 		: string;
	public run_emission_service : string;
	public get_car_form			: string;
	public get_car_form_status  : string;
	public status_quotes        : string;
	public get_contacts			: string;
	public status_contacts 	    : string;
	public run_service_gmm 		: string;
	public run_service_mascotas : string;
	// public get_new_car_model    : string;

	public get_razas 			: string;

	// URLS ADMIN
	public quote_comment 		: string;
	public search				: string;

	// CONTACTAT EMAIL
	public contact_email		: string;

	// SHIPS
	public contractors_filter 	: string;
	public add_contractor  		: string;
	public carga_quote			: string;
	public carga_quote_file		: string;
	public edit_quote			: string;
	public emitir_jah			: string;
	public contratante_carga_full: string;
	public create_group			: string;
	public create_ind_pol		: string;
	public login_local			: string;
	public exchange_rate		: string;
	public beneficiary_list		: string;
	public insured 				: string;
	public get_groups			: string;
	public save_client_user 	: string;
	public save_admin_user 	: string;
	public get_countries 	 	: string;
	public grupo_filter 		: string;
	public all_group 		: string;
	public containers_list 		: string;
	public coverages_list 		: string;
	public commodity_list 		: string;
	public specify_rates		: string;
	public pdf_carga			: string;
	public add_beneficiary 		: string;
	public services 			: string;
	public commodities			: string;
	public commodities_package	: string;
	public user_by_group		: string;
	public insured_filter		: string;
	public all_insured_filter	: string;
	public delete_group			: string;
	public client_services		: string;
	public patch_perm			: string;
	public send_email_carga		: string;
	public search_carga_quote 	: string;
	public status_carga_filter  : string;	
	public filter_carga_quotes  : string;
	public report_carga_quotes  : string;
	public report_carga_quotes_v2:string;
	public download_certificates : string;
	public paid_quote  			: string;
	public delete_carga_quote  	: string;
	public users  				: string;
	public agencias             : string;
	public all_agencias         : string;
	public aseguradora          : string;
	public media  				: string;
	public complemento  		: string;
	// public report_client		: string;
	public report_account_statements    : string;
	public report_client_commissions    : string;
	public report_adviser_commissions   : string;
	public factura              : string;
	public comision             : string;

	constructor() {

		let mc;

		if(sessionStorage['config']) {
			this.config = JSON.parse(sessionStorage['config']);
			mc = this.config.mc;
		} else {
			mc  = 'http://127.0.0.1:8001/';
		}

		this.login					= mc  +  'us-login-multicotizador';


		this.car_types 				= mc  + 'get-car-type/'
		this.car_types  	     	= mc  + 'get-car-type/';
		this.car_brands        		= mc  + 'get-car-brand/';
		this.car_years         		= mc  + 'get-car-year/';
		this.car_models        		= mc  + 'get-car-model/';

		// URLS SEGUNDO FORMULARIO (INFORMACIÓN GENERAL)
		this.get_cities        		= mc + 'get-cities/';
		this.get_cols_by_city  		= mc + 'get-cols-by-state-city/';
		this.get_cols_by_zip   		= mc + 'get-cols-by-cp/';
		this.get_states        		= mc + 'get-states';
		this.get_zip_by_col    		= mc + 'get-cp-by-state-city-col/';

		// URLS COMPARACIÓN DE COTIZACIONES
		this.get_new_car_model 		= mc + 'get-new-car-model/';
		this.run_another_service	= mc + 'run-another-service/';
		this.get_services      		= mc + 'get-services';
		this.pdf    		     	= mc + 'pdf/';
		this.run_service       		= mc + 'run-service/';
		this.send_email	     		= mc + 'send-email';
		this.send_email_pets		= mc + 'email-pets';
		this.run_emission_service 	= mc + 'run-emision-service/'
		this.get_car_form		 	= mc + 'get-car-form';
		this.get_car_form_status  	= mc + 'get-car-form-status';
		this.status_quotes        	= mc + 'cotizaciones/statusCotizaciones/';
		this.get_contacts			= mc + '/contactos';
		this.status_contacts 		= mc + 'cotizaciones/statusContactos/';
		this.run_service_gmm		= mc + 'run-gmm-cotizacion/';
		// this.get_new_car_model    = mc + 'get-new-car-model/';

		// URLS ADMIN
		this.quote_comment 			= mc + 'quote-comment/';
		this.search 				= mc + 'get-car-filter'

		// CONTACT EMAIL
		this.contact_email			= mc + 'email-contact';

		// SHIPS
		this.contractors_filter 	= mc + 'contratante-carga-filter';
		this.add_contractor 		= mc + 'contratante-carga/';
		this.carga_quote			= mc + 'carga-quotes/';
		this.carga_quote_file			= mc + 'carga-quote-file/';
		this.edit_quote			= mc + 'quote-edition-save/';
		this.emitir_jah				= mc + 'emitir-jah/';
		this.contratante_carga_full = mc + 'contratante-carga-full/';
		this.create_group 			= mc + 'crear-grupo/';
		this.create_ind_pol 		= mc + 'individual-pol/';
		this.login_local 			= mc + 'login-local/';
		this.exchange_rate			= mc + 'get-rate-exchange';
		this.beneficiary_list 		= mc + 'listar-beneficiario';
		this.insured 				= mc + 'asegurados/';
		this.get_groups				= mc + 'groups';
		this.save_client_user		= mc + 'crear-usuario-cliente';
		this.save_admin_user		= mc + 'crear-usuario-admin';
		this.get_razas				= mc + 'get-razas';
		this.get_countries 			= mc + 'listar-paises';
		this.grupo_filter			= mc + 'grupo-carga-filter/';
		this.all_group				= mc + 'all-group';
		this.containers_list		= mc + 'listar-contenedores';
		this.commodity_list 		= mc + 'listar-mercancia';
		this.coverages_list			= mc + 'listar-coberturas';
		this.specify_rates 			= mc + 'especificar-tasas/';
		this.pdf_carga				= mc + 'pdf-carga/';
		this.pdf_gnp				= mc + 'pdf-certificado-gnp/';
		this.add_beneficiary 		= mc + 'agregar-beneficiario/';
		this.run_service_mascotas	= mc + 'run-mascotas-cotizacion/';
		this.services				= mc + 'services/';
		this.commodities 			= mc + 'mercancias/';
		this.commodities_package	= mc + 'paquetes-mercancias/';
		this.user_by_group			= mc + 'user-by-group/';
		this.insured_filter 		= mc + 'asegurado-carga-filter/';
		this.all_insured_filter 	= mc + 'all-asegurados/';
		this.delete_group 			= mc + 'eliminar-grupo/';
		this.client_services		= mc + 'config-services/';
		this.patch_perm				= mc + 'patch-perm/';
		this.send_email_carga		= mc + 'send-email-carga';
		this.search_carga_quote 	= mc + 'status-carga-filter/';
		this.filter_carga_quotes	= mc + 'filter-carga-quotes/';
		this.report_carga_quotes 	= mc + 'report-carga-quotes/';
		this.report_carga_quotes_v2 = mc + 'report-insurance/';
		this.download_certificates 	= mc + 'get-certificates/';
		this.paid_quote 			= mc + 'paid-out/';
		this.delete_carga_quote 	= mc + 'delete-carga-quote/';
		this.users 					= mc + 'users-admin/';
		this.agencias 				= mc + 'agencia/';
		this.all_agencias 			= mc + 'all-agencias/';
		this.aseguradora			= mc + 'aseguradora/';
		this.media 					= mc + 'media/';
		this.complemento            = mc + 'complemento/';
		// this.report_client			= mc + 'report-client-quotes';
		this.report_account_statements	= mc + 'report-client-quotes-account-statements';
		this.report_client_commissions	= mc + 'report-client-quotes-client-commissions';
		this.report_adviser_commissions	= mc + 'report-client-quotes-adviser-commissions';
		this.factura	            = mc + 'factura/';
		this.comision	            = mc + 'comision/';


	}

}


// WEBPACK FOOTER //
// ../esscalo_funcionalidad/src/config/urls.ts